export const DETAIL_VIEW = Symbol("DETAIL_VIEW_HANDLER");

export const ASYNC_DIALOG = Symbol("ASYNC_DIALOG_HANDLER");

export const DIALOGS = Symbol("ASYNC_DIALOGS");
export const DRAWER_VIEW = Symbol("DRAWER_VIEW");
